<template>
     <div class="col-12 card" >
        <Toast />

        <Dialog header="REPORTAR INCIDENCIA" v-model:visible="showReportMotiveModal" :style="{width: '50vw'}">
            <div  class="grid" >
                <div class="col-12">
                    <input type="text" v-model="motivo" class="p-text p-component w-full incidencia inputfield" placeholder="Motivo">
                </div>
                <div v-for="report in reportOptions" class="col-12">
                    <Button  :label="report.name" class="reportButton w-full" @click="setReport(report.id)" />
                </div>
            </div>
        </Dialog>

        <div class="flex justify-content-between flex-wrap">
          <div>
            <h1>PPP {{ otiName(order.id) }} - {{order.oc}} | Cód: {{order.codigo}} </h1>
          </div>
          <div class="">
            <div :class="'status_box status-'+priorityClass" @click="updatePriority()">PRIORIDAD {{priorityName }}</div>
          </div>
          <div class="">  
            <Button class="ml-2" label="REPORTAR INCIDENCIA" @click="showReportMotiveModal = true" />
          </div>
        </div>

        <div class="">
          <div class="formgrid grid">

            <div class="field col-4">
              <label for="detail">CLIENTE</label>
              <span id="detail" type="text" class="inputfield w-full">
                {{ giveMeName(order.client, 'client') }}
              </span>
            </div>

            <div class="field col-8">
              <label for="details">DETALLE</label>
              <span id="details" type="text" class="inputfield w-full">
                {{ order.obs }}
              </span>
            </div>

          </div>
        </div>

        <!--
        <div class="">
          <div class="formgrid grid">
            <div class="field col-3">
              <label for="alto">ALTO</label>
              <span id="alto" type="text" class="inputfield w-full">
                {{ order.alto }}
              </span>
            </div>

            <div class="field col-3">
              <label for="ancho">ANCHO</label>
              <span id="ancho" type="text" class="inputfield w-full">
                {{ order.ancho }}
              </span>
            </div>

            <div class="field col-3">
              <label for="espesor">ESPESOR</label>
              <span id="espesor" type="text" class="inputfield w-full">
                {{ order.espesor }}
              </span>
            </div>

            <div class="field col-3">
              <label for="plisas">PLISAS</label>
              <span id="plisas" type="text" class="inputfield w-full">
                {{ order.plisas }}
              </span>
            </div>


          </div>
        </div>
        
        <div class="">
          <div class="formgrid grid">
            <div class="field col">
              <label for="detail">MATERIAL</label>
              <span id="detail" type="text" class="inputfield w-full">
                {{ giveMeName(order.material, 'material') }}
              </span>
            </div>
            <div class="field col">
              <label for="detail">MAQUINA</label>
              <span id="detail" type="text" class="inputfield w-full">
                {{ giveMeName(order.machine_id, 'machine') }}
              </span>
            </div>

            <div class="field col">
              <label for="detail">TRATAMIENTO</label>
              <span id="detail" type="text" class="inputfield w-full">
                {{ giveMeName(order.tratamiento, 'tratamiento') }}
              </span>
            </div>
            <div class="field col">
              <label for="detail">CLIENTE</label>
              <span id="detail" type="text" class="inputfield w-full">
                {{ giveMeName(order.client_id, 'client') }}
              </span>
            </div>

          </div>
        </div>
        -->
        <div class="" v-if="order?.plans && order.plans.length">
          <div class="formgrid grid">
            <div class="field col">
              <label for="detail">PLANOS</label>

              <div>
                <div v-for="(plan, index) in order.plans" :key="index">
                  <Button
                    :label="plan.name"
                    icon="pi pi-file-pdf"
                    iconPos="left"
                    class="btn plan_button"
                    @click="downloadFile(plan)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="(order.status==2 || order.status=='2' || order.status==1 || order.status=='1') && order.logs && order.logs.length>0 && order.logs[0].observations != ''" class="status_products_logs col-12">
            <div class="">
                <div class="formgrid grid" >
                    <div class="field col-12">
                      <span type="text" class="inputfield w-full">
                        {{ order.logs[0].observations }}
                      </span>
                    </div>                    
                </div>
            </div>
        </div>

        <h3>PRODUCTOS</h3>
        <div v-for="prod in order.productos" v-if="order.productos && order.productos.length" class="mt-3 status_products col-12" >
        
            <div class="" v-if="status==prod.status_flujo">
                <div class="formgrid grid">
                    <div class="field col-3">
                      <label for="alto">PRODUCTO</label>              
                    </div>
                    <div class="field col-2">
                      <label for="alto">CANT</label>              
                    </div>
                    <div class="field col-1">
                      <label for="alto">CLASE - EFIC.</label>
                    </div>
                    <div class="field col-2">
                      <label for="alto">SECTOR</label>
                    </div>
                    <div class="field col-1">
                      <label for="alto">EMBALADO</label>              
                    </div>
                    <div class="field col-1">
                      <label for="alto">EXPRESS</label>
                    </div>
                    <div class="field col-1">
                      <label for="alto">LOGO</label>
                    </div>
                    <div class="field col-1">
                      
                    </div>
                </div>
                <div class="formgrid grid" >
                    <div class="field col-3">
                      <span type="text" class="inputfield w-full">
                        <b>{{ prod.producto.name }}</b> <br>
                        <small>
                          Medida: {{prod.medida}}
                        </small>
                        <small v-if="prod.material">
                        <br>
                          Material: {{prod?.material?.name}}
                        </small>                        
                      </span>
                    </div>
                    <div class="field col-2">
                      <span type="text" class="inputfield w-full">
                        {{ prod.cantidad }}
                      </span>
                    </div>
                    <div class="field col-1">
                      <span type="text" class="inputfield w-full">
                        {{ prod.clase }}
                      </span>
                    </div>
                    <div class="field col-2">
                      <span type="text" class="inputfield w-full">
                        {{ prod.sector }}
                      </span>
                    </div>
                    <div class="field col-1">
                      <span type="text" class="inputfield w-full">
                        {{ prod.embalado }}
                      </span>
                    </div>
                    <div class="field col-1">
                      <span type="text" class="inputfield w-full">
                        {{ prod.express }}
                      </span>
                    </div>
                    <div class="field col-1">
                      <span type="text" class="inputfield w-full">
                        {{ prod.logo }}
                      </span>
                    </div>
                    <div class="field col-1">
                      <small v-if="prod.seem == null">
                        <div class="status_box status-high" @click="updateSeem(prod.op_flujo_id)">Marcar como Visto</div>
                      </small>
                    </div>
                    <div class="field col-12" >
                      <span type="text" class="inputfield w-full">
                        <OtiClockOp @statusChange="statusChanged"
                          :order="prod"
                        />
                      </span>
                    </div>
                </div>
            </div>
        </div>

         <div>
        <div class="mt-3">
          <div class="col-12">
            
          </div>
        </div>
        </div>
     </div>
</template>
<script>
import CrudService from "./../../services/crud.service.js";
import OtiActions from "../OtiActions.vue"; 
import OtiClockOp from "./../OtiClockOp.vue";
export default {
    props: ['order', 'status'],
    components: {
      OtiActions,
      OtiClockOp,
    },
    data() {
        return {
            showReportMotiveModal: false,
            materials: [],
            machines: [],
            tratamientos: [],
            clients: [],
            plans: [],
            motivo: '',
            reportOptions: [
                {name: 'Gerencia', id: 1},
                {name: 'Calidad', id: 3},
                {name: 'Planta', id: 6},
                {name: 'Ingeniería', id: 5},

            ],
        }
    },
    computed: {
        priorityName() {
          switch (this.order.priority) {
            case 'high':
              return "ALTA";
            case 'medium':
              return "MEDIA";
            default:
              return "NORMAL";
          }
        },
        priorityClass(){
          if (this.order.priority == 'high' || this.order.priority == 'medium') {
            return this.order.priority;
          }

          return "normal";
        },
    },
    created() {
        if (!this.loggedIn) {
            this.$router.push('/');
        }
        this.getMaterials();
        this.getMachines();
        this.getTratamientos();
        this.getClients();
        //this.getPlans();
        this.getIncidencesTypes();
    },
    methods: {
        statusChanged() {
            console.log('statusChanged')
            //location.reload();
            setInterval(
              function () {
                location.reload();
              }.bind(this),
              5000
            );
        }, 
        otiName(id=null) {
          return ("0000" + id).slice(-4);        
        },
        otiSeem(prod) {
          console.log('prod')
          console.log(prod)
          //let seems = prods.filter((dat) => dat.seem == null);
          //return seems.length;
        },
        downloadFile ({ file }) {
            const API_URL = process.env.VUE_APP_ROOT_API;
            let url = API_URL + '/planos/download/' + file;          
            window.open(url);
        },
        setReport(id) {
            if (! this.motivo) {
                this.motivo = 'Ingrese la descripción...';
                return;
            }
            let data = { 'incidencia_tipo_id': id, 'descripcion': this.motivo, 'order': this.order }
            CrudService.createCRUD("incidencia", "incidencia", data).then((data) => {
                this.showReportMotiveModal = false
                this.motivo = '';                
                this.$toast.add({
                    severity: "success",
                    summary: "Éxito!",
                    detail: "Creado correctamente.",
                    life: 3000,
                });
                //location.reload()
            });
        },
        updateSeem(op_flujo_id) {
            let data = { 'op_flujo_id': op_flujo_id }
            CrudService.createCRUD("marcar-visto", "marcar-visto", data).then((data) => {
                location.reload()
            });
        },
        getMaterials() {
            CrudService.getCRUD('material', 'material').then(response => {
                this.materials = response;
            });
        },
        getIncidencesTypes() {
            CrudService.getCRUD('tipos-incidencias', 'tipos-incidencias').then(response => {
                this.reportOptions = response;
            });
        },
        getMachines() {
            CrudService.getCRUD('maquinaria', 'maquinaria').then(response => {
                this.machines = response;
            });
        },
        getTratamientos() {
            CrudService.getCRUD('tratamiento', 'tratamiento').then(response => {
                 this.tratamientos = response;
            });
        },
        getClients() {
            CrudService.getCRUD('cliente', 'cliente').then(response => {
                this.clients = response;
            });
        },
        getPlans() {
            CrudService.getCRUD('planes', 'planes', this.order.id).then(response => {
                this.plans = response;
            });
        },
        giveMeName(id, type) {
            let name = '';
            if (type == 'material') {
                this.materials.forEach(material => {
                    if (material.id == id) {
                        name = material.name;
                    }
                });
            } else if (type == 'machine') {
                this.machines.forEach(machine => {
                    if (machine.id == id) {
                        name = machine.name;
                    }
                });
            } else if (type == 'tratamiento') {
                this.tratamientos.forEach(tratamiento => {
                    if (tratamiento.id == id) {
                        name = tratamiento.name;
                    }
                });
            } else if (type == 'client') {
                this.clients.forEach(client => {                    
                    if (client.id == id) {
                        name = client.code;
                    }
                });
            }
            return name;
        }
    }
    
}
</script>


<style scoped>
.field > label {
  color: #9a9a9a;
  letter-spacing: 0.64px;
  font-size: 16px;
  text-transform: uppercase;
}

.field > span {
  display: block;
  text-align: left;
  letter-spacing: 0px;
  color: #0c0c0c;
  opacity: 1;
  border: none;
  background: transparent;
  font-size: 20px;
  line-height: 25px;
}

.plan_button {
  background: white;
  border: 1px solid #d8d8d8;
  font-size: 16px;
  line-height: 19px;
  color: #9a9a9a;
  width: 483px;
  height: 56px;
  text-align: left;
}

.plan_button:hover {
  border: 1px solid #d8d8d8;
  font-size: 16px;
  line-height: 19px;
  color: #ffffff;
  width: 483px;
  height: 56px;
}

.reportButton {
      font-size: 1.4rem;
    text-transform: uppercase;
    margin: 1%;
}

.incidencia {
    height: 3rem;
}

.status_products {
    border: 1px solid #ECCE94;
    background-color: #F1F1D3;
    color: #6F6C6C;
}
.status_products_logs  {
    border: 1px solid #A32A2A;
    background-color: #EEA6A6;
    color: #550B0B;
}

.status_box {
    display: inline-block;          
    font-weight: bolder;
    text-align: center;
    padding: 5px;
    text-transform: uppercase;
}
.status-normal {
      border: 1px solid #6B6B6B;
      background-color: #E4E5E5;
      color: #6F6C6C;
}
.status-high {
      border: 1px solid #E53C3C;
      background-color: #FC7A7A;
      color: #fff;
}
.status-medium {
      border: 1px solid #ECD222;
      background-color: #F0E6A4;
      color: #585858;
}

</style>

